var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","dense":""}},[_c('img',{attrs:{"src":"logo-v2-600x200.png","height":"40px"}})]),_c('v-main',[_c('router-view')],1),_c('v-footer',{staticClass:"justify-center"},[_vm._v("© "+_vm._s(_vm.company_name)+" "+_vm._s(_vm.getCurrentYear()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }